module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyrightPage",
    attrs: {
      "id": "cop01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ULE")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OUR")]), _vm._v(" F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("REAKIN")]), _vm._v("’ R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ETIREMENT")]), _vm._v("."), _c('br'), _vm._v("\n\nCopyright © 2009 by Michael Parness."), _c('br'), _vm._v("\n\nAll rights reserved."), _c('br'), _vm._v("\nPrinted in the United States of America."), _c('br'), _vm._v("\nFor information, address St. Martin’s Press,"), _c('br'), _vm._v(" 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('span', {
    staticClass: "xrefURL"
  }, [_c('a', {
    attrs: {
      "href": "http://www.stmartins.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Parness, Michael.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Rule your freakin’ retirement: how to retire rich by actively managing your assets / Michael Parness.—1st ed."), _c('br'), _vm._v("                  p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightTexta"
  }, [_vm._v("    ISBN-13: 978-1-4299-6256-8"), _c('br'), _vm._v("    ISBN-10: 0-312-37575-1")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("1. Retirement income—Planning. 2. Retirement—Planning. 3. Old age pensions. 4. Investments. 5. Finance, Personal. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightTexta"
  }, [_vm._v("    HG179.P237 2009")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightTexta"
  }, [_vm._v("    332.024'014—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightTextb"
  }, [_vm._v("2008035448")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightTexta"
  }, [_vm._v("  First Edition: March 2009")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightTexta"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightTexta"
  }, [_vm._v("  10 9 8 7 6 5 4 3 2 1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70198b16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ruleyourfreakinretirement_cop01.vue
// module id = 66
// module chunks = 0